module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_9005.eb216385.png";